export default {"src":"/_next/static/media/scanner.2086db7d.svg","height":20,"width":24};